import axiosClient from '@clients/axiosClient';

export type ITimelineType =
    | 'TRANSACTION'
    | 'STATEMENT'
    | 'CARD'
    | 'CONFIRMATION'
    | 'CASHIN'
    | 'SKELETON'
    | 'NOTIMELINE';

export type TimelineItemValidationResultsItemStatus =
    | 'SKIPPED'
    | 'APPROVED'
    | 'REJECTED';

export type ITimelineDataItemStatement = {
    id: number;
};

export type ITimelineItemDataItem = {
    id?: number;
    contract_amount?: number;
    response_code?: string;
    amount?: number;
    to_name?: string;
    principal_amount?: number;
    cardholderbilling_amount?: number;
    currency_code?: string;
    org_operation?: Record<string, unknown>;
    pre_authorization?: string;
    soft_descriptor?: string;
    local_amount?: number;
    latitude?: number;
    longitude?: number;

    authorization_code?: string;

    merchant_city?: string;
    dcc?: string;
    processing_code?: string;
    program_id?: string;
    entry_mode?: string;
    retrieval_reference_number?: string;
    number_of_installments?: string;
    principle_amount?: string;
    settlement_currency_literal?: string;
    settlement_currency_code?: string;
    network?: string;
    nsu?: string;
    merchant_category_group?: string;
    installments?: number;
    currency_literal?: string;
    cash_back_amount?: number;
    airport_tax?: number;
    interest_rate?: number;
    mti?: string;
    installment_amount?: number;
    merchant_category_code?: string;
    settlement_currency_rate?: number;
    merchant_state_or_country?: string;
    card_type?: string;
    card_id?: number;
    cardholder_currency_rate?: number;
    card_name?: string;
    entry_mode_literal?: string;
    customer_id?: string;
    settlement_currency_amount?: number;
    custom_code?: string;

    credits?: number;
    debits?: number;
    cycle_closing_date?: string;
    payment_status?: string;
    minimum_payment?: number;
    statement?: ITimelineDataItemStatement;
    current_balance?: number;
    value?: number;

    stage?: string;
    name?: string;
    printed_name?: string;
    type?: string;
    status?: string;

    validation_results?: TimelineItemValidationResults[];
};

export type TimelineItemValidationResults = {
    name: string;
    status: TimelineItemValidationResultsItemStatus;
    reason: string;
    description: string;
    additional_data?: object;
};

export type ITimelineData = {
    item: ITimelineItemDataItem;
};

export type ITimelineItem = {
    type: ITimelineType;
    account_id: number;
    category: string;
    tenant_account_timestamp: string;
    timestamp: string;
    data: ITimelineData;
    correlation_id: string;
    next_cursor?: string;
};

export type ITimeline = {
    has_next: boolean;
    next_cursor: string;
    count: number;
    items: ITimelineItem[];
};

type IGetTimelineDetails = {
    accountId: number;
    next_cursor?: string;
    pageSize?: number;
    order?: string;
    timelineDateStart?: string;
    timelineDateEnd?: string;
    timelineType?: string;
    categoryType?: string;
};

const timeline = () => {
    const client = axiosClient();

    return {
        async getTimeline({
            accountId,
            next_cursor = null,
            pageSize = 25,
            order,
            timelineDateStart,
            timelineDateEnd,
            timelineType,
            categoryType,
        }: IGetTimelineDetails) {
            const { data } = await client.get<ITimeline>(`events/v4/timeline`, {
                headers: { 'x-account-id': accountId },
                params: {
                    nextCursor: next_cursor,
                    limit: pageSize,
                    order: order,
                    beginDate: timelineDateStart,
                    endDate: timelineDateEnd,
                    type: timelineType,
                    category: categoryType,
                },
            });
            return data;
        },
    };
};

export default timeline;
